import React from "react";
import { format } from "date-fns";

interface DateBadgeProps {
  date: string | Date;
}

export const DateBadge: React.FC<DateBadgeProps> = ({ date }) => {
  const parsedDate = new Date(date);

  return (
    <div className="text-center my-4">
      <span className="bg-gray-300 text-gray-800 px-3 py-1 rounded-full text-sm">
        {format(parsedDate, "MMMM d, yyyy")}
      </span>
    </div>
  );
};
